<script>
    import LoadingAnim from "./loadingAnim.svelte"
    import AirshowCard from "./airshowCard.svelte"
    const optional = x => x || '';
    import { Link } from "svelte-navigator";


    import { operationStore, query } from '@urql/svelte';
    const getHomeContent = operationStore(`
    {
      home: entry(section: "pages", slug: "home") {
        id
        title
        ... on home_Entry {
          tagLine
          bigTitle
          backgroundImage {
            title
            url @transform(handle: "mainimage", immediately: true)
          }
        }
      }
      airshows: entries(section: "airshows", limit: 6) {
        title
        slug
        ... on airshows_default_Entry {
          teaser
          mainImage {
            url @transform (handle:"grid", immediately: true)
          }
        }
      }
    }`);
    query(getHomeContent);
</script>
<div class="home">
    {#if $getHomeContent.fetching}
        <LoadingAnim/>
    {:else if $getHomeContent.error}
        <p>Oh no... {$getHomeContent.error.message}</p>
    {:else}
        <div class="mainimage" style="background-image: url({$getHomeContent.data.home.backgroundImage[0].url})">
            <div class="content">
                <div class="title">
                    <h1>{$getHomeContent.data.home.bigTitle}</h1>
                    <h2>{$getHomeContent.data.home.tagLine}</h2>
                </div>
            </div>
        </div>
        <div class="content airshow-overview">
            <h1>Zuletzt besuchte Airshows</h1>
            <div class="jetnoise-grid">
                {#each $getHomeContent.data.airshows as airshow}
                    <AirshowCard title="{airshow.title}" mainImageSrc="{optional(airshow.mainImage[0]).url}" teaser="{airshow.teaser}" slug="{airshow.slug}"/>
                {/each}
            </div>
            <div class="links">
                <Link class="link-btn" to="/airshows">alle Airshows ansehen</Link>
            </div>
        </div>

    {/if}
</div>
<style lang="scss">
    .mainimage {
      background-size: cover;
      background-position: center center;
      height: calc(100vh - var(--header-footer-height));
    }

    .title {
      padding-top: 50vh ;
      float: right;
      text-align: center;
      color: white;
      h1 {
        font-size: 80px;
        padding: 0 25px 15px 25px;
        border-bottom: 3px solid white;
        margin-bottom: 10px;
      }
      h2 {
        padding-top: 8px;
        font-size: 20px;
        font-weight: normal;
      }
    }
    .home {
      .airshow-overview {
        padding: var(--large-margin) 0 0 0;
      }
    }
    .links {
      margin-top: var(--default-margin);
      display: flex;
      justify-content: center;
    }
    @media screen and (max-width: 700px) {
      .mainimage {
        background-position: top right 66%;
      }
      .title {
        padding-top: 61vh;
        float: none;
        width: fit-content;
        margin: 0 auto;
        h1 {
          font-size: 50px;
          padding: 0 12px 10px 12px;
        }
        h2 {
          padding-top: 8px;
          font-size: 16px;
          font-weight: normal;
        }
      }
    }
</style>